import React from "react";
import { observer } from "mobx-react";
import { Divider, Stack, Link, HStack, Button } from "@chakra-ui/react";
import { useEffectOnce } from "usehooks-ts";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { renderInnerHtml } from "@/helpers/dom";
import { H1, H2 } from "@/components/Heading";
import { AppLink } from "@/routing/AppLink";
import { WelcomeFooter } from "./WelcomeFooter";
import { OverdosePlanningCallout } from "@/components/OverdosePlanningCallout";
import { telemetry } from "@/telemetry";

export const WelcomePage = observer(() => {
  const { activeLanguage, reset } = useStore();
  const language = translations.pages["welcome"][activeLanguage];

  useEffectOnce(reset);

  return (
    <Stack spacing="14">
      <Stack spacing={{ base: 8, md: 16 }}>
        <Stack
          spacing="8"
          alignItems="center"
          textAlign="center"
        >
          <H1>{renderInnerHtml(language.heading)}</H1>
          <H2>{renderInnerHtml(language.heading_description)}</H2>
        </Stack>

        <HStack
          justifyContent="center"
          spacing={{ base: "8", md: "16" }}
          flexDirection={{ base: "column", lg: "row" }}
          alignItems={{ base: "center", lg: "stretch" }}
        >
          <Link
            as={AppLink}
            to="/select-province"
            onClick={() =>
              telemetry.trackEvent("entry_selected", { entry: "order" })
            }
          >
            <Button
              px="16"
              fontSize="14px"
            >
              {renderInnerHtml(language.button1_label)}
            </Button>
          </Link>
          <Link
            as={AppLink}
            to="/emergent-signin"
            onClick={() =>
              telemetry.trackEvent("entry_selected", {
                entry: "emergent_signin",
              })
            }
          >
            <Button
              px="16"
              fontSize="14px"
            >
              {renderInnerHtml(language.button2_label)}
            </Button>
          </Link>
          <Link
            as={AppLink}
            to="/indigenous/portal"
            onClick={() =>
              telemetry.trackEvent("entry_selected", {
                entry: "indigenous_portal",
              })
            }
          >
            <Button
              px="16"
              fontSize="14px"
              width="100%"
              height={{ base: "50px", lg: "100%" }}
            >
              {renderInnerHtml(language.button3_label)}
            </Button>
          </Link>
        </HStack>

        <OverdosePlanningCallout />
      </Stack>

      <Divider />
      <WelcomeFooter />
    </Stack>
  );
});
